import { FeatureFlags } from '@constants/featureFlags';
import { Feature, FeatureFlagState } from '@store/featureFlags/types';
import { printLog } from '@utils/printUtils';

type SetFeatureFlagStore = (updates: Partial<FeatureFlagState>) => void;

export function createFeatureFlagUtils(
  setStore: SetFeatureFlagStore,
  getFeatureFlags: () => Promise<Feature[]>,
  getStoreFlags: () => Feature[],
) {
  const initializeFeatureFlags = async () => {
    setStore({
      isLoading: true,
      isError: false,
      errorMessage: undefined,
    });

    try {
      const flags = await getFeatureFlags();
      setStore({
        isLoading: false,
        isError: false,
        errorMessage: undefined,
        loaded: true,
        flags,
      });
    } catch (error) {
      setStore({
        isLoading: false,
        isError: true,
        loaded: true,
        errorMessage: (error as Error).message,
        flags: [] as Feature[],
      });
    }
  };

  let cachedFlags: Feature[] | undefined;
  let enabledSet = new Set<string>();

  const getEnabledFlags = (): Set<string> => {
    const flags = getStoreFlags();

    if (flags !== cachedFlags) {
      cachedFlags = flags;
      enabledSet = new Set<string>();

      for (const f of flags) {
        if (f.value.toLowerCase() === 'enabled') {
          enabledSet.add(f.id.toLowerCase());
        }
      }
    }
    return enabledSet;
  };

  const isFeatureFlagEnabled = (value: FeatureFlags): (() => boolean) => {
    const key = value.toLowerCase();
    printLog(key, getEnabledFlags());
    return () => getEnabledFlags().has(key);
  };

  return { initializeFeatureFlags, isFeatureFlagEnabled };
}
